import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppNavigationMainState } from './types'

export const initialMainState: AppNavigationMainState = {
  isConfirmModalVisible: false,
  isFormValid: true,
}

export const mainSlice = createSlice({
  name: 'appNavigationMain',
  initialState: initialMainState,
  reducers: {
    showConfirmModal: state => {
      state.isConfirmModalVisible = true
    },
    hideConfirmModal: state => {
      state.isConfirmModalVisible = false
    },
    setFormValid: (state, action: PayloadAction<boolean>) => {
      state.isFormValid = action.payload
    },
  },
})

export const reducer = mainSlice.reducer
export const { showConfirmModal, hideConfirmModal, setFormValid } =
  mainSlice.actions

export default mainSlice
